<script>
import HeaderNav from "@/layout/HeaderNav.vue";
import FooterBar from "@/layout/FooterBar.vue";
import ShortcutMenu from "@/layout/ShortcutMenu.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Layout",
  components: {
    FooterBar,
    HeaderNav,
    ShortcutMenu
  }
}
</script>

<template>
  <div>
    <HeaderNav :only-show-bottom="false"></HeaderNav>
    <!-- 主要内容区域 -->
    <main>
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </main>

    <!-- 页脚 -->
    <FooterBar :only-show-bottom="false"></FooterBar>

    <ShortcutMenu></ShortcutMenu>
  </div>
</template>

<style scoped>

</style>
